import { Tutorial } from './tutorial.model';

const cdnURL: string = 'https://cdn.redacaonota1000.com.br/guias';

export const tutorials: Tutorial[] = [
  {
    label: 'Criação de tarefas',
    video: { id: 'AsMS94InOmk', provider: 'YOUTUBE' },
    files: [
      {
        url:   `${ cdnURL }/Guia para coordenadores - Criar tarefa de redacao.pdf`,
        title: 'Criar tarefa de redacao'
      },
      {
        url:   `${ cdnURL }/Guia para coordenadores - Orientação para corretores - Tarefa cadastrada - Inclusao_Visualizacao_Alteracao.pdf`,
        title: 'Tarefa cadastrada - Inclusão, visualização e alteração'
      }
    ]
  },
  {
    label: 'Acompanhamento e edição de tarefas',
    video: { id: 'mta6T4d4Mow', provider: 'YOUTUBE' },
    files: [
      {
        url: `${ cdnURL }/Guia para coordenadores - Editar Tarefa.pdf`,
        title: 'Editar Tarefa'
      },
      {
        url: `${ cdnURL }/Guia para coordenadores - Reabrir Tarefas.pdf`,
        title: 'Reabrir Tarefas'
      },
      {
        url: `${ cdnURL }/Guia para coordenadores - Encerrar Tarefa.pdf`,
        title: 'Encerrar Tarefa'
      }
    ]
  },
  {
    label: 'Reescrita',
    video: { id: 'ywkc_RV1AgE', provider: 'YOUTUBE' }
  },
  {
    label: 'Menu da tarefa',
    video: { id: 'dDWW_w9XOSQ', provider: 'YOUTUBE' },
    files: [
      {
        url: `${ cdnURL }/Guia para coordenadores - Acompanhar Tarefas.pdf`,
        title: 'Acompanhar Tarefas'
      },
      {
        url:   `${ cdnURL }/Guia para coordenadores - Gerar Excel por tarefa.pdf`,
        title: 'Gerar Excel por tarefa'
      },
      {
        url:   `${ cdnURL }/Guia para coordenadores - Como imprimir folhas em branco.pdf`,
        title: 'Como imprimir folhas em branco'
      }
    ]
  },
  {
    label: 'Status do aluno na tarefa',
    video: { id: 'PA9sNe1OJGQ', provider: 'YOUTUBE' }
  },
  {
    label: 'Laudo de correção e análise de resultados',
    video: { id: 'PdSGalT_9KM', provider: 'YOUTUBE' },
    files: [
      {
        url: `${ cdnURL }/Guia para coordenadores - Resultados.pdf`,
        title: 'Resultados'
      },
      {
        url: `${ cdnURL }/Guia para coordenadores - Ver resultados por aluno.pdf`,
        title: 'Ver resultados por aluno'
      }
    ]
  },
  {
    label: 'Extração de notas',
    video: { id: 'IL-t7YbJ8F8', provider: 'YOUTUBE' },
    files: [
      {
        url:   `${ cdnURL }/Guia para coordenadores - Extrair Nota por Turma.pdf`,
        title: 'Extrair nota por turma'
      }
    ]
  },
  {
    label: 'Upload de redações',
    video: { id: 'rYPtwABd8h8', provider: 'YOUTUBE' },
    files: [
      {
        url:   `${ cdnURL }/Guia para coordenadores - Como fazer Upload das redacoes.pdf`,
        title: 'Como fazer upload das redacoes'
      }
    ]
  },
  {
    label: 'Cadastro de temas',
    video: { id: '4pG1T1476eo', provider: 'YOUTUBE' },
    files: [
      {
        url:   `${ cdnURL }/Guia para coordenadores - Cadastrar temas.pdf`,
        title: 'Cadastrar temas'
      }
    ]
  },
  {
    label: 'Cadastro de alunos',
    video: { id: 'MhgNnM5n7VI', provider: 'YOUTUBE' },
    files: [
      {
        url:   `${ cdnURL }/Guia para coordenadores - Cadastramento de alunos.pdf`,
        title: 'Cadastramento de alunos'
      },
      {
        url:   `${ cdnURL }/Guia para coordenadores - Inativar o aluno.pdf`,
        title: 'Inativar o aluno'
      },
      {
        url:   `${ cdnURL }/Guia para coordenadores - Como alterar a Senha_dos alunos.pdf`,
        title: 'Como alterar a senha dos alunos'
      },
      {
        url:   `${ cdnURL }/Guia para coordenadores - Como alterar a turma dos alunos.pdf`,
        title: 'Como alterar a turma dos alunos'
      }
    ]
  },
  {
    label: 'Cadastro de professores e equipe',
    video: { id: 'BpZpRk7MFEU', provider: 'YOUTUBE' },
  },
  {
    label: 'Dashboard do coordenador e resultados',
    video: { id: 'vdJvD6Nr3yw', provider: 'YOUTUBE' }
  },
  {
    label: 'Como visualizar plágio',
    files: [
      {
        url:   `${ cdnURL }/Guia para coordenadores - Visualizar link plagio 70 ou mais.pdf`,
        title: 'Visualizar link plagio 70% ou mais'
      }
    ]
  },
];
